// Page margins for the remote DOCX/PDF converter. Values mirror the editor's
// visual page styling in `ckeditor.css` (`.ck-editor__editable` padding:
// `1cm 2cm 2cm`). Kept here so the editor look and the exported document
// match without depending on the premium Pagination plugin.
export const pageMargins = {
    top: '1cm',
    right: '2cm',
    bottom: '2cm',
    left: '2cm',
};
